/* A page's identifying facts in its own body (T170): label and value pairs on a
   wrapping row, each value a link where it names a record. They read on the page's
   own ground rather than on the banner's navy, so the colours are the body's. */
.facts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-4);
  margin: 0 0 var(--space-3);
  font-size: var(--font-size-small);
}

.fact {
  display: inline-flex;
  gap: var(--space-1);
  min-width: 0;
}

.label {
  color: var(--text-muted);
}

.label::after {
  content: ':';
}

.value {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link {
  color: var(--navy-primary);
  font-weight: var(--font-weight-semibold);
  text-decoration: none;
}
